// extracted by mini-css-extract-plugin
export default {"ellipse-container":"Ellipse_ellipse-container__jzrme"};